import { useQuery } from "@tanstack/react-query";
import {
  getPermissionsList,
  getPermissionsForRole,
  getRoles,
  getPermissionsForUser,
} from "@/modules/access/api/permissions";

export function usePermissionsList(options = {}) {
  return useQuery({
    queryKey: ["permissions", "list"],
    queryFn: () => getPermissionsList(),
    staleTime: 1000 * 60 * 10,
    ...options,
  });
}

export function usePermissionsForRole(role, options = {}) {
  return useQuery({
    queryKey: ["permissions", "role", role],
    queryFn: () => getPermissionsForRole(role),
    enabled: !!role,
    ...options,
  });
}

export function useRoles(options = {}) {
  return useQuery({
    queryKey: ["roles"],
    queryFn: () => getRoles(),
    staleTime: 1000 * 60 * 60,
    ...options,
  });
}

export function usePermissionsForUser(userId, options = {}) {
  const token = localStorage.getItem("token");
  return useQuery({
    queryKey: ["permissions", "user", userId ? userId : token],
    queryFn: () => getPermissionsForUser(userId),
    // 30 minutos de staleTime ya evita refetches innecesarios; no hace
    // falta pisar refetchOnMount/refetchOnWindowFocus/refetchOnReconnect
    // (quedaron de una migración de v4 -> v5 de TanStack Query junto con
    // cacheTime, que en v5 se llama gcTime -- v4 ignoraba cacheTime en
    // silencio, sin avisar).
    staleTime: 1000 * 60 * 30, // 30 minutes
    gcTime: 1000 * 60 * 60, // 1 hour
    ...options,
  });
}
